import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  open: boolean;
  setOpen: (o: boolean) => void;
  cancelInvitation: MouseEventHandler<HTMLButtonElement>;
  email: string;
}

const polyglotPrefix =
  "pages.data_sharing.manage_invitation.cancel_invitation."

/*
 * renders a dialog asking the user to confirm that they want to cancel an invitation
 */
export function CancelInvitationDialog(props: Props) {
  const {
    setOpen, open: isOpen, cancelInvitation, email,
  } = props

  const polyglot = usePolyglot()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
    >
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}title`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          <div>
            {polyglot.t(
              `${polyglotPrefix}description_one`,
              { email },
            )}
          </div>
          <div>
            {polyglot.t(`${polyglotPrefix}description_two`)}
          </div>
        </DialogBody>
        <DialogButton
          stylePreset="destructive"
          onClick={cancelInvitation}
          id="confirm-cancel-invitation-btn"
        >
          {polyglot.t(`${polyglotPrefix}cancel_invitation_cta`)}
        </DialogButton>
        <DialogButton stylePreset="primary">
          {polyglot.t(`${polyglotPrefix}close_cta`)}
        </DialogButton>
      </DialogContent>
    </Dialog>
  )
}
